import { useAppDispatch, useAppSelector } from "app/hooks"
import { useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import { useFailed } from "features/notification/hooks"
import {
  getFavoriteMeals,
  resetFavoriteMeals,
  resetFavoriteMealsState,
} from "../favoriteMealsSlice"
import PATHS from "router/paths"

export const useFavoriteMeals = () => {
  const favoriteMeals = useAppSelector(
    (state) => state.favoriteMeals.favoriteMeals,
  )
  const getFavoriteMealsLoading = useAppSelector(
    (state) => state.favoriteMeals.getFavoriteMealsLoading,
  )
  const getFavoriteMealsFailed = useAppSelector(
    (state) => state.favoriteMeals.getFavoriteMealsFailed,
  )

  const isNoFavoriteMeals = useAppSelector(
    (state) => state.favoriteMeals.isNoFavoriteMeals,
  )

  const hasMore = useAppSelector(
    (state) => state.favoriteMeals.hasMoreFavoriteMeals,
  )

  const page = useAppSelector((state) => state.favoriteMeals.favoriteMealsPage)
  const dispatch = useAppDispatch()
  const location = useLocation()

  const isFirstLoad = useRef(true)
  const previousPathnameRef = useRef(location.pathname)

  const loadMore = async () => {
    const currentPage = isFirstLoad.current ? 0 : page

    if (getFavoriteMealsLoading && currentPage !== 0) {
      return Promise.resolve()
    }

    isFirstLoad.current = false
    return (await dispatch(getFavoriteMeals({ page: currentPage + 1 }))) as any
  }

  useFailed(getFavoriteMealsFailed)

  //   const deleteFavoriteMealSuccess = useAppSelector((state) => state.meal.dele)
  //   useSuccess(() => {}, [])

  useEffect(() => {
    // Update the previous pathname ref
    previousPathnameRef.current = location.pathname

    return () => {
      // Only reset if navigating away from favorite meals related routes
      const isFavoriteMealsRoute =
        previousPathnameRef.current === PATHS.app.myFoods.root ||
        previousPathnameRef.current.startsWith("/favorite-meal/")

      if (!isFavoriteMealsRoute) {
        dispatch(resetFavoriteMeals())
      }
    }
  }, [location.pathname, dispatch])

  return {
    favoriteMeals,
    getFavoriteMealsLoading,
    isNoFavoriteMeals,
    loadMore,
    hasMore,
  }
}

export const useResetFavoriteMealState = () => {
  const dispatch = useAppDispatch()

  return () => {
    dispatch(resetFavoriteMealsState())
  }
}
